var lib_core = require("lib-core");

var AbstractPadstackData = require("./abstractPadstackData.js");

var defaultPasteExpansion = 0;

var SmdPadstackData = function (topCopper, maskEnable, maskOverride, maskExpansion, pasteEnable, pasteOverride, pasteExpansion, connectionType) {
    var self = this;

    AbstractPadstackData.call(this, topCopper, maskEnable, maskOverride, maskExpansion, connectionType);

    this.pasteEnable = this.value("pasteEnable", true);
    this.pasteOverride = this.value("pasteOverride", true);
    this.pasteExpansion = this.value("pasteExpansion", true);

    this.topSolderPaste = this.cachedFunction("topSolderPaste",
        function () {
            return self.getSolderPaste();
        },
        [this.topCopper, this.pasteEnable, this.pasteOverride, this.pasteExpansion]
    );

    if(pasteExpansion != undefined) this.pasteExpansion(pasteExpansion);
    if(pasteEnable != undefined) this.pasteEnable(pasteEnable);
    if(pasteOverride != undefined) this.pasteOverride(pasteOverride);
};

lib_core.inherit(SmdPadstackData, AbstractPadstackData);
lib_core.JsonParser.registerClass(SmdPadstackData, "SmdPadstackData");

module.exports = SmdPadstackData;

SmdPadstackData.prototype.getSolderPaste = function() {
    if(this.pasteEnable()) {
        var shape = this.topCopper().clone();
        var expansion = this.pasteOverride() ? this.pasteExpansion() : defaultPasteExpansion;
        shape.width(shape.width()+expansion);
        shape.height(shape.height()+expansion);
        if(shape.rx) shape.rx(shape.rx()+expansion/2);
        if(shape.ry) shape.ry(shape.ry()+expansion/2);
        return shape;
    } else {
        return null;
    }
};
